import React from 'react';
import Makanan from './CardsImages/makanan.png'
import Elektronik from './CardsImages/elektronik.png'
import Buku from './CardsImages/buku.png'
import Mainan from './CardsImages/mainan.png'
import Medis from './CardsImages/medis.png'
import Pakaian from './CardsImages/pakaian.png'
import Uang1 from './CardsImages/Uang1.png'
import { Link } from 'react-router-dom';

const Cards3 = () => {
    return (
        <div id="features2">
            <div className="icons">
                {/* <img src={Icon} alt="" width="800" height="100" /> */}
                <div className="donations">
                    <div className="button-wrapper">
                        <div className="category-btns">
                            <div className="icons"><img src={Makanan} alt="" width="80" /></div>
                            <span>Makanan</span>
                        </div>
                        <div className="category-btns">
                            <div className="icons"><img src={Elektronik} alt="" width="80" /></div>
                            <span>Elektronik</span>
                        </div>
                        <div className="category-btns">
                            <div className="icons"><img src={Mainan} alt="" width="80" /></div>
                            <span>Mainan Anak</span>
                        </div>
                        <div className="category-btns">
                            <div className="icons"><img src={Buku} alt="" width="80" /></div>
                            <span>Buku</span>
                        </div>
                        <div className="category-btns">
                            <div className="icons"><img src={Pakaian} alt="" width="80" /></div>
                            <span>Pakaian</span>
                        </div>
                        <div className="category-btns">
                            <div className="icons"><img src={Medis} alt="" width="80" /></div>
                            <span>Medis</span>
                        </div>
                    </div>
                </div>
            </div>
            <div id="category">
                <div className="title-category">
                    <h3>Bantu mereka yang membutuhkan dengan beragam cara</h3>
                </div>
            </div>
            <br />
            <p className="text">Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                Elit sodales in malesuada parturient facilisis.
                Sagittis, leo, urna turpis libero nisl posuere pretium.
                Morbi sed pellentesque in auctor odio fringilla. Malesuada luctus feugiat risus in.
            </p>
            <button className="btn-2"><Link to="/Pelajari">Pelajari lebih lanjut</Link></button>
        </div>
    )
}
export default Cards3;